<template>
  <div class="settlement-order" @keyup.enter="enterSearch">
    <el-form class="table-search-bar" inline :model="handForm" ref="handForm">
      <el-form-item label="使用期限" prop="time">
        <el-date-picker
          v-model="handForm.time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="经营组织" prop="internalCompany">
        <el-select v-model="handForm.internalCompany" placeholder="请选择经营组织" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="山东京博石油化工有限公司" value="1194877555086491668"></el-option>
          <el-option label="京博（海南）新材料有限公司" value="1094530434974004288"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="SAP状态" prop="sapStatus">
        <el-select v-model="handForm.sapStatus" placeholder="请选择SAP状态" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="订单同步成功" value="1"></el-option>
          <el-option label="交货单同步成功" value="2"></el-option>
          <el-option label="转码同步失败" value="0"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="原协议编号" prop="protocolNo">
        <el-input v-model="handForm.protocolNo" placeholder="请输入协议编号" clearable></el-input>
      </el-form-item>
            <el-form-item label="原提货单号" prop="originalTakOrder">
        <el-input v-model="handForm.originalTakOrder" placeholder="请输入原提货单号" clearable></el-input>
      </el-form-item>
      <el-form-item label="订单编号" prop="orderNo">
        <el-input v-model="handForm.orderNo" placeholder="请输入订单编号" clearable></el-input>
      </el-form-item>
      <el-form-item label="提货单号" prop="deliveryNo">
        <el-input v-model="handForm.deliveryNo" placeholder="请输入提货单号" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="handData"
      v-loading="loading"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="orderMain.orderCode"
        label="订单号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.takeOrderNo"
        label="提货单号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.originalAgreemet"
        label="原协议编号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.originalOrder"
        label="原订单号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.originalTakOrder"
        label="原提货单号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderMain.deptName"
        label="经营组织"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderItem.itemName"
        label="商品名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="orderItem.itemCode"
        label="商品编码"
        :show-overflow-tooltip="true">
      </el-table-column>
      <!-- <el-table-column
        prop="businessOrg"
        label="经营组织"
        :show-overflow-tooltip="true">
      </el-table-column> -->
      <el-table-column
        prop="orderMain.originalCunstomer"
        label="客户名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="销售数量"
        :key="Math.random()"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.orderItem.itemNum}}{{scope.row.orderItem.itemUnit}}
        </template>
      </el-table-column>
      <el-table-column
        label="币种"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span v-if="scope.row.currencyType == '1'">CNY</span>
          <span v-else-if="scope.row.currencyType == '2'">USD</span>
          <span v-else-if="scope.row.currencyType == '3'">EUR</span>
          <span v-else>{{ scope.row.currency || 'CNY' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="销售单价"
        :key="Math.random()"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.orderItem.discountedPrice}}
        </template>
      </el-table-column>
      <el-table-column
        label="销售总额"
        :key="Math.random()"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.orderMain.payAmount}}
        </template>
      </el-table-column>
      <el-table-column
        label="客户单价"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.orderMain.cunstomerPrice }}
        </template>
      </el-table-column>
      <el-table-column
        label="客户销售总额"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.orderMain.cunstomerTotalAmount }}
        </template>
      </el-table-column>
      <el-table-column
        label="结算依据"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.orderMain.receiptSend === 1 ? '实收' : scope.row.orderMain.receiptSend === 2 ? '实发' : '实发' }}
        </template>
      </el-table-column>
      <el-table-column
        label="结算数量"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ getSettleNum(scope.row) }}{{ scope.row.orderItem ? scope.row.orderItem.itemUnit : '' }}
        </template>
      </el-table-column>
      <el-table-column
        label="结算总额"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ formatSettleMoney(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column width="120"
                       label="SAP同步状态"
                       :show-overflow-tooltip="true">
                       <template slot-scope="scope">
          {{ scope.row.syncSapStatusDetails }}
        </template>
      </el-table-column>
      <el-table-column
        prop="orderMain.sapResult"
        width="120"
        label="sap返回信息"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        :key="Math.random()"
        label="操作"
        width="500">
        <template slot-scope="scope">
          <el-button v-if="scope.row.syncSapStatus === null || scope.row.syncSapStatus === 1"
            size="mini"
            @click="handleSyncSapOrder(scope.$index, scope.row)"
            v-permission="'0101403'">同步SAP</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.hyhntotal"
      :current-page="listState.currentPage"
      background>
    </el-pagination>
    <el-row class="export-row" type="flex" justify="end">
      <el-col :span="4">
        每页
        <el-select class="width100" v-model="exportForm.size" @change="handleExportSizeChange">
          <el-option v-for="item in sizeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        条
      </el-col>
      <el-col :span="4">
        第
        <el-select class="width100" v-model="exportForm.page">
          <el-option v-for="item in pageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        页
      </el-col>
      <el-col :span="3">
        <el-button v-permission="'0101401'" type="primary" @click="handleExport">导出为CSV文件</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'SettlementOrderHaiYun',
  data () {
    return {
      loading: false,
      handForm: {
        time: [],
        internalCompany: '',
        sapStatus: '',
        protocolNo: '',
        orderNo: '',
        deliveryNo: '',
        originalTakOrder: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      exportForm: {
        size: 1000,
        page: 1
      },
      sizeOptions: [
        {
          label: '500',
          value: 500
        },
        {
          label: '1000',
          value: 1000
        },
        {
          label: '3000',
          value: 3000
        },
        {
          label: '5000',
          value: 5000
        }
      ]
    }
  },
  computed: {
    ...mapState({
      handData: state => state.moYuanSettlementOrder.hyhnlist,
      listState: state => state.moYuanSettlementOrder.hyhnlistState
    }),
    pageOptions () {
      const total = this.listState.hyhntotal
      const size = this.exportForm.size
      let totalPage = Math.floor(total / size)
      if (total % size) {
        totalPage++
      }
      const arr = []
      for (let index = 1; index <= totalPage; index++) {
        arr.push({
          label: index,
          value: index
        })
      }
      return arr
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getHyhnSettlementOrderList', 'exportHyhnEnergyOrder', 'syncSapHandOrder']),
    // 获取结算数量
    getSettleNum (row) {
      if (row.orderMain.receiptSend === 1 && row.orderMain.totalReceipt !== undefined) {
        return row.orderMain.totalReceipt
      } else if ((row.orderMain.receiptSend === 2 || row.orderMain.receiptSend === null) && row.orderItem) {
        return row.orderItem.itemNum
      }
      return ''
    },
    // 格式化结算总额
    formatSettleMoney (row) {
      const settleNum = this.getSettleNum(row)
      if (!settleNum || !row.orderItem || row.orderItem.discountedPrice === undefined) {
        return ''
      }
      const settleMoney = settleNum * row.orderItem.discountedPrice
      // 超过2位小数保留2位，遵循四舍五入
      if (settleMoney.toString().includes('.') &&
          settleMoney.toString().split('.')[1].length > 2) {
        return settleMoney.toFixed(2)
      }
      return settleMoney
    },
    // 搜索
    handleSearch () {
      const params = {
        orderTime_Min: this.handForm.time ? this.handForm.time[0] : '',
        orderTime_Max: this.handForm.time ? this.handForm.time[1] : '',
        pageNo: 1,
        pageSize: 10,
        isTransfer: '0',
        manualOrderType: 1,
        orderSettlementType: 4,
        deptId: this.handForm.internalCompany,
        originalAgreemet: this.handForm.protocolNo,
        orderNo: this.handForm.orderNo,
        takeOrderNo: this.handForm.deliveryNo,
        originalTakOrder: this.handForm.originalTakOrder
      }
      this.getHyhnSettlementOrderList(params)
    },
    // 回车搜索
    enterSearch (e) {
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 重置
    handleReset () {
      this.$refs.handForm.resetFields()
      this.handForm = {
        time: [],
        internalCompany: '',
        sapStatus: '',
        protocolNo: '',
        originalTakOrder: '',
        orderNo: '',
        deliveryNo: '',
        pageNo: 1,
        pageSize: 10
      }
      this.handleSearch()
    },

    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.exportForm.page = 1
    },
    sapStatusFormat (row) {
      switch (row.syncSapStatus) {
        case 0:
          return '成功'
        case 1:
          return '失败'
        default:
          return '未同步'
      }
    },
    // 导出
    handleExport () {
      if (!Array.isArray(this.handData) || this.handData.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }

      const params = {
        orderTime_Min: this.handForm.time ? this.handForm.time[0] : '',
        orderTime_Max: this.handForm.time ? this.handForm.time[1] : '',
        pageNo: 1,
        pageSize: this.exportForm.size,
        isTransfer: '0',
        manualOrderType: 1,
        orderSettlementType: 4,
        deptId: this.handForm.internalCompany,
        originalAgreemet: this.handForm.protocolNo,
        orderNo: this.handForm.orderNo,
        takeOrderNo: this.handForm.deliveryNo,
        originalTakOrder: this.handForm.originalTakOrder
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.exportHyhnEnergyOrder(params).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '海韵海南公司间结算订单.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => {})
    },
    handleSizeChange (val) {
      this.getHyhnSettlementOrderList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getHyhnSettlementOrderList({ pageNo: val })
    },
    handleSyncSapOrder (index, row) {
      this.$confirm('是否同步SAP订单信息?', '确认', {
        confirmButtonText: '同意',
        cancelButtonText: '拒绝',
        type: 'warning'
      }).then(() => {
        const params = {
          orderId: row.orderMain.orderId
        }
        this.syncSapHandOrder(params).then(res => {
          this.$message.success('操作成功')
          this.handleSearch()
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.export-row {
  margin-top: 10px;
}
.width100{
  width: 100px;
}
</style>
